import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import CategoryDetailLayer from "../../components/service-catalog/CategoryDetailLayer";

const CategoryDetailPage = () => {
  return (
    <>
      <MasterLayout>
        <Breadcrumb
          routePath="/service-catalog"
          routeName="Service Category"
          title="View Service Category"
        />
        <CategoryDetailLayer />
      </MasterLayout>
    </>
  );
};

export default CategoryDetailPage;

// Route to add next to your other service-catalog routes:
// <Route path="/service-category/:id" element={<CategoryDetailPage />} />
